import * as React from 'react';
import { SnackbarProvider, useSnackbar } from 'notistack';
import PropTypes from 'prop-types';
import { Check, X } from 'lucide-react';
import { useNotifications } from '../../axiosMiddleware/HeaderContext';
import styles from './Notification.module.css';

const DURATION_NOTIFICATION = 1500;

const NotificationAction = React.memo(({ id, closeSnackbar, notificationItem }) => (
  <button
    type="button"
    onClick={() => closeSnackbar(id)}
    style={{
      background: 'none',
      border: 'none',
      display: 'flex',
      position: 'absolute',
      width: '100%',
      left: '0px',
      paddingLeft: 'var(--space-xs)',
      boxSizing: 'border-box',
      cursor: 'pointer',
      alignItems: 'center',
    }}
  >

    <p
      style={{
        color: 'var(--color-text-primary)',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        maxWidth: 'calc(100% - 36px)',
        fontSize: '1rem',
      }}
    >
      {notificationItem}
    </p>
    <div
      style={{
        background: 'none',
        width: '36px',
        height: '36px',
        border: 'none',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: notificationItem === 'Action succeeded !' ? 'var(--field-valid)' : 'var(--field-invalid)',
        marginLeft: 'auto',
      }}
    >
      {notificationItem === 'Action succeeded !' ? <Check size={20} /> : <X size={20} /> }
    </div>
  </button>
));

NotificationAction.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  closeSnackbar: PropTypes.func.isRequired,
  notificationItem: PropTypes.string.isRequired,
};

const renderNotificationAction = function (notificationItem, closeSnackbar) {
  return function (el) {
    return (
      <NotificationAction
        id={el}
        closeSnackbar={closeSnackbar}
        notificationItem={notificationItem}
      />
    );
  };
};

function Notification() {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const { notifications, setNotifications } = useNotifications();

  const handleSnackBar = React.useCallback(() => {
    if (notifications && notifications.length > 0) {
      notifications.forEach((notificationItem, index) => {
        console.log(notificationItem);
        enqueueSnackbar((notificationItem), {
          autoHideDuration: DURATION_NOTIFICATION,
          action: renderNotificationAction(notificationItem, closeSnackbar),
          'data-testid': `notificationItem${index}`,
          style: {
            backdropFilter: 'blur(10px)',
            borderRadius: 'var(--radius-sm)',
            // color: 'var(--color-text-primary)',
            height: '40px',
            background: 'var(--glass-bg)',
            border: '1px solid var(--color-border)',
          },
        });
      });
      setNotifications([...notifications].slice(1));
    }
  }, [notifications, enqueueSnackbar, renderNotificationAction]);

  React.useEffect(() => {
    handleSnackBar();
  }, [notifications, handleSnackBar]);

  return null;
}

function ApiResponseHandlerReturn() {
  return (
    <SnackbarProvider
      maxSnack={3}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
    >
      <Notification className={styles.hello} />
    </SnackbarProvider>
  );
}

export default ApiResponseHandlerReturn;
